import { render, staticRenderFns } from "./IpBlockedModal.vue?vue&type=template&id=6c8d2362&"
import script from "./IpBlockedModal.vue?vue&type=script&lang=js&"
export * from "./IpBlockedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports